// --- Modules
import Node, { payload } from './Node';

class Subnet extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Subnet'
    });
  }
};

export default {
  create: (opts) => {
    let item = new Subnet(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
